import ReducerUtils   from "../../../utils/ReducerUtils"
import Actions        from "../../../model/constant/actions"

interface StatusByAccount{
  [accountId:string] : boolean
}
const Running = ReducerUtils.createReducer<StatusByAccount>({},{
  [Actions.PACY_MIGRATION_RUNNING] : (state,action)=>({...state, [action.accountId]: action.status})
})

export default Running
